import { Injectable } from '@angular/core';
import { Statement } from 'src/app/shared/models/saude/statement';
import { BaseService } from 'src/app/shared/services/base.service';
import { environment } from 'src/environments/environment';
@Injectable({ providedIn: 'root' })
export class DeclarationService extends BaseService {
    getProducts() {
        const url = `${environment.portalApi}/Declaration/ProductTypes`;
        return this.http.get(url, { headers: this.createHeader() });
    }
    getModels(productId?: number) {
        const url = `${environment.portalApi}/Declaration/DeclarationTypes?productTypeId=` + productId;
        return this.http.get(url, { headers: this.createHeader() });
    }
    getModelsUser(productId?: number) {
        const url = `${environment.portalApi}/Declaration/UserDeclarationTypes?productTypeId=` + productId;
        return this.http.get(url, { headers: this.createHeader() });
    }
    getDeathPensionBeneficiaries(productId?: number) {
        const url = `${environment.portalApi}/Declaration/ListDeathPensionBeneficiaries`;
        return this.http.get(url, { headers: this.createHeader() });
    }
    getAlimonyBenefited(productId?: number) {
        const url = `${environment.portalApi}/Declaration/ListAlimonyBenefited`;
        return this.http.get(url, { headers: this.createHeader() });
    }
    getAvailableActiveLinkedSelfSponsoredYears() {
        const url = `${environment.portalApi}/Declaration/AvailableActiveLinkedSelfSponsoredYears`;
        return this.http.get(url, { headers: this.createHeader() });
    }
    getAvailableMonthlyFees() {
        const url = `${environment.portalApi}/Declaration/AvailableMonthlyFees`;
        return this.http.get(url, { headers: this.createHeader() });
    }
    getDeclarations(filter: Statement) {
        const url = `${environment.portalApi}/Declaration/Declarations?` + this.paramsToQueryString(filter);
        return this.http.get(url, { headers: this.createHeader() });
    }
    getDeclaration(code: string) {
        const url = `${environment.portalApi}/Declaration/` + code;
        return this.http.get(url, { headers: this.createHeader(), responseType: 'blob' });
    }
    postGeneratePDF(request: any) {
        const url = `${environment.portalApi}/Declaration/GeneratePDF`;
        return this.http.post(url, request, { headers: this.createHeader(), responseType: 'blob' });
    }
}
